/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useMemo } from 'react';
import { getAssetsReportsUrl } from '@jira/servicedesk__insight-common-utils-insight-urls/src/getLandingPageUrl.tsx';
import { ASSETS_REPORTS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';
import { MENU_ID_ASSETS_REPORTS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import ChartBarIcon from '@atlaskit/icon/core/chart-bar';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { useAssetsUIAnalytics } from '../../use-assets-ui-analytics/index.tsx';

const jsmAssetsReports = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports',

	defaultMessage: 'Reports',
	description: 'Assets dropdown item to link customer to Reports page.',
});

export const ReportsMenuItem = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const reportsLink = useMemo(() => getAssetsReportsUrl(), []);
	const { fireUINavigationItemAnalytics } = useAssetsUIAnalytics();

	return (
		<Nav4MenuLinkItem
			elemBefore={
				<ChartBarIcon
					label={formatMessage(jsmAssetsReports)}
					color="currentColor"
					spacing="spacious"
				/>
			}
			href={reportsLink}
			menuId={MENU_ID_ASSETS_REPORTS}
			onClick={() => fireUINavigationItemAnalytics(ASSETS_REPORTS)}
		>
			{formatMessage(jsmAssetsReports)}
		</Nav4MenuLinkItem>
	);
};
